export default "__VITE_ASSET__Cva4_hli__"